module.exports = __webpack_public_path__ + "static/media/iconMagic2.4c075e62.svg";